import { gql } from "@apollo/client";

export const SET_ONLINE_STATUS = gql`
  mutation setOnlineStatus($onlineStatus: Boolean!) {
    setOnlineStatus(onlineStatus: $onlineStatus)
  }
`;
